import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CHIP}/v3/chips`;

async function create(payload) {
  try {
    const rawChipStatusId =
      payload?.chipStatusId ??
      payload?.statusChip ??
      payload?.statusChipId ??
      payload?.ChipStatusId;

    const normalizedChipStatusId =
      rawChipStatusId === undefined || rawChipStatusId === null || rawChipStatusId === ""
        ? 0
        : Number(rawChipStatusId);

    
    const requestPayload = {
      LineNumber: payload?.lineNumber ?? payload?.LineNumber ?? "",
      Iccid: payload?.iccid ?? payload?.Iccid ?? "",
      MobileOperatorId:
        payload?.mobileOperatorId ?? payload?.MobileOperatorId ?? 0,
      ChipStatusId: Number.isNaN(normalizedChipStatusId) ? 0 : normalizedChipStatusId,
    };

    let response = await api.post(basePath, JSON.stringify(requestPayload));
    let treated = errorHandling.handleResponse(response, "chipService.create");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.create");
    return null;
  }
}

async function getChipStatus(chipStatusId) {
  try {
    const normalizedChipStatusId =
      chipStatusId === undefined || chipStatusId === null || chipStatusId === ""
        ? 0
        : chipStatusId;

    const response = await api.get(`${basePath}/status/${normalizedChipStatusId}`);
    const treated = errorHandling.handleResponse(
      response,
      "chipService.getChipStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.getChipStatus");
    return null;
  }
}

async function update(payload) {
  try {
    const chipId = payload?.chipId ?? payload?.ChipId ?? payload?.id;
    const rawChipStatusId =
      payload?.ChipStatusId ??
      payload?.chipStatusId ??
      payload?.statusChipId ??
      payload?.statusChip;

    const normalizedChipStatusId =
      rawChipStatusId === undefined || rawChipStatusId === null || rawChipStatusId === ""
        ? 0
        : Number(rawChipStatusId);

    const {
      statusChip,
      statusChipId,
      chipStatusId,
      ...restPayload
    } = payload ?? {};

    const requestPayload = {
      ...restPayload,
      ChipStatusId: Number.isNaN(normalizedChipStatusId) ? 0 : normalizedChipStatusId,
    };

    if (chipId === undefined || chipId === null || chipId === "") {
      return null;
    }

    let response = await api.put(
      `${basePath}/${chipId}`,
      JSON.stringify(requestPayload)
    );
    let treated = errorHandling.handleResponse(response, "chipService.update");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.update");
    return null;
  }
}

async function save(payload) {
  if (payload.id > 0) {
    payload.chipId = payload.id;
    await update(payload);
    return payload.id;
  }
  return await create(payload);
}

async function list(payload = {}) {
  try {
    const queryParams = new URLSearchParams();

    const chipId = payload?.ChipId ?? payload?.chipId ?? payload?.id;
    const lineNumber = payload?.LineNumber ?? payload?.lineNumber;
    const iccid = payload?.Iccid ?? payload?.iccid;
    const mobileOperatorId =
      payload?.MobileOperatorId ?? payload?.mobileOperatorId;
    const chipStatusId =
      payload?.ChipStatusId ??
      payload?.chipStatusId ??
      payload?.statusChipId ??
      payload?.statusChip;

    const normalizedChipStatusId =
      chipStatusId === undefined || chipStatusId === null || chipStatusId === ""
        ? ""
        : Number(chipStatusId);

    if (chipId !== undefined && chipId !== null && chipId !== "") {
      queryParams.append("ChipId", chipId);
    }

    if (lineNumber !== undefined && lineNumber !== null && lineNumber !== "") {
      queryParams.append("LineNumber", lineNumber);
    }

    if (iccid !== undefined && iccid !== null && iccid !== "") {
      queryParams.append("Iccid", iccid);
    }

    if (
      mobileOperatorId !== undefined &&
      mobileOperatorId !== null &&
      mobileOperatorId !== ""
    ) {
      queryParams.append("MobileOperatorId", mobileOperatorId);
    }

    if (normalizedChipStatusId !== "" && !Number.isNaN(normalizedChipStatusId)) {
      queryParams.append("ChipStatusId", normalizedChipStatusId);
    }

    const queryString = queryParams.toString();
    const url = queryString ? `${basePath}?${queryString}` : basePath;

    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "chipService.list");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.list");
    return null;
  }
}

async function listMobileOperator() {
  try {
    const payload = {
      pageSize: 500,
      pageNumber: 1,
      mobileOperatorId: -1,
    };

    let response = await api.post(
      `${basePath}/MobileOperator`,
      JSON.stringify(payload)
    );
    let treated = errorHandling.handleResponse(
      response,
      "MobileOperatorService.listMobileOperator"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "MobileOperatorService.listMobileOperator");
    return null;
  }
}

async function searchByLineNumber(lineNumber) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: lineNumber,
  };

  try {
    let response = await api.post(`${basePath}/numberLine`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByLineNumber"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByLineNumber");
    return null;
  }
}

async function searchByICCID(iccid) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: iccid,
  };

  try {
    let response = await api.post(`${basePath}/numberLine`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByICCID"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByICCID");
    return null;
  }
}

export const chipService = {
  list,
  create,
  update,
  save,
  getChipStatus,
  searchByICCID,
  searchByLineNumber,
  listMobileOperator,
};
